
import { Component, Vue } from "vue-property-decorator";
import ComplianceProfile from "@/modules/Compliance/Profile/ComplianceProfile.vue";

const TYPE_COMPLIANCE_PROFILE = "complianceProfile";

@Component({
  components: { ComplianceProfile },
})
export default class Summary extends Vue {
  type = TYPE_COMPLIANCE_PROFILE;
}
